export function SET_BEGIN_DATE({ commit }, [begin_date]) {
    commit('SAVE_BEGIN_DATE', [begin_date])
}

export function SET_END_DATE({ commit }, [end_date]) {
    commit('SAVE_END_DATE', [end_date])
}